"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SillyErrorBoundary = /** @class */ (function (_super) {
    __extends(SillyErrorBoundary, _super);
    function SillyErrorBoundary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SillyErrorBoundary.prototype.componentDidCatch = function (error) {
        this.props.onError(error);
    };
    SillyErrorBoundary.getDerivedStateFromError = function () {
        // has to be here, causing warning otherwise 😂
        return {};
    };
    SillyErrorBoundary.prototype.render = function () {
        return this.props.children;
    };
    return SillyErrorBoundary;
}(react_1.default.PureComponent));
exports.SillyErrorBoundary = SillyErrorBoundary;
//# sourceMappingURL=SillyErrorBoundary.js.map